<script setup>
  import { ref, onMounted, onBeforeUnmount, onBeforeMount } from 'vue';
  import { useRouter, useRoute } from 'vue-router';
 

  const body = document.getElementsByTagName("body")[0];
 
  const route = useRoute();
  const router = useRouter();
  const verifying = ref(true);
  const verified = ref(false);
  const error = ref(null);
  
  onMounted(async () => {
    const token = route.query.token;

    if (!token) {
      error.value = 'No verification token provided.';
      verifying.value = false;
      return;
    }

    try {
      const res = await fetch(`/auth/verify-email?token=${token}`);
      if (!res.ok) {
        error.value = await res.text();
        verifying.value = false;
        return;
      }

      verified.value = true;
      verifying.value = false;

      setTimeout(() => {
        router.push('/signin?verified=1');
      }, 3000);
    } catch (err) {
      error.value = 'Something went wrong during verification.';
      verifying.value = false;
    }
  });
</script>

<template>
  <div>
    <navbar isBtn="bg-gradient-light" />
    <main class="main-content mt-0 min-vh-100 d-flex flex-column align-items-center justify-content-center">
      <div class="container text-center">
        <div v-if="verifying">
          <h4>Verifying your email...</h4>
          <p>Please wait a moment.</p>
        </div>

        <div v-else-if="verified">
          <h4 class="text-success">Email verified successfully!</h4>
          <p>You will be redirected to sign in shortly.</p>
        </div>

        <div v-else>
          <h4 class="text-danger">Verification Failed</h4>
          <p>{{ error }}</p>
          <router-link to="/signin" class="btn btn-outline-primary mt-3">Return to Login</router-link>
        </div>
      </div>
    </main>
    <app-footer />
  </div>
</template>

<style scoped>
  .container {
    max-width: 600px;
  }
</style>
